import { render } from "./HotelTable.vue?vue&type=template&id=522da750"
import script from "./HotelTable.vue?vue&type=script&lang=js"
export * from "./HotelTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__